import { Button, Card, Checkbox, Col, Form, message, Row } from "antd";
import { FC, useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import sliderApi from "../../../../api/sliderApi";
import InputField from "../../../../components/InputField";
import InputNumberWrap from "../../../../components/InputNumber";
import Loading from "../../../../components/Loading";
import TopContent from "../../../../components/TopContent";
import PageWrap from "../../../../layout/PageWrap";
import { appRoutes } from "../../../../routes/routes";
import { formItemLayoutSm } from "../../../../utils/constants";
import { loadFile } from "../../../../utils/functions/loadFile";
import { messages } from "../../../../utils/messages";

interface SliderHomeFormProps {
  type: number;
}
const SliderHomeForm: FC<SliderHomeFormProps> = ({ type }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { id } = useParams();
  const [file, setFile]: any = useState();
  const { data, isLoading }: any = useQuery(
    ["home-slider", id],
    () => sliderApi.getHomeSliderDetails(id),
    {
      enabled: !!id && type === 2,
      onSuccess: (dt: any) => {
        if (dt.statusCode !== 200) {
          message.error(dt?.data?.message ?? messages.error);
        }
      },
    }
  );
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();
  const [image, setImage]: any = useState();
  const handleUpload = async (file: any) => {
    if (file) {
      setFile(file);
      await loadFile(file);
      setImage(file.urlImg);
    }
  };
  const mutationEdit = useMutation(sliderApi.editHomeSlider, {
    onSuccess: async (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.updateSuccess);
        await queryClient.invalidateQueries("home-slider");
        navigate(appRoutes.SLIDERS.HOME.LIST);
        window.scrollTo(0, 0);
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });
  const mutationAdd = useMutation(sliderApi.addHomeSlider, {
    onSuccess: async (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.addSuccess);
        await queryClient.invalidateQueries("home-slider");
        navigate(appRoutes.SLIDERS.HOME.LIST);
        window.scrollTo(0, 0);
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });
  const onSubmit = (dt: any) => {
    const formData = new FormData();
    if (file) formData.append("banner", file);
    formData.set("url", dt.url ?? "");
    formData.set("index", dt.index ?? "");
    if (dt.hienthi !== undefined) formData.set("hienthi", dt.hienthi);
    if (type === 2) mutationEdit.mutate({ id: id, data: formData });
    if (type === 1) mutationAdd.mutate(formData);
  };

  return (
    <PageWrap
      title="Slidershow chính"
      content={
        <>
          <TopContent
            content={
              <Row>
                <Col>
                  <b>Slidershow chính</b>
                </Col>
              </Row>
            }
          />
          <div className="content">
            {isLoading ? (
              <Loading />
            ) : (
              <Card bordered={false}>
                <Form {...formItemLayoutSm} className="slider-form">
                  {(image || data?.data?.photo) && (
                    <div className="cash_img">
                      <img
                        src={
                          image ??
                          process.env.REACT_APP_DOMAIN + data?.data?.photo
                        }
                        alt=""
                      />
                    </div>
                  )}
                  <InputField
                    isImage={true}
                    name="banner"
                    control={control}
                    rules={
                      type === 1
                        ? {
                            required: "Vui lòng chọn hình ảnh",
                          }
                        : undefined
                    }
                    label="Hình ảnh"
                    errorMsg={errors?.banner?.message}
                    onChange={(e: any) => {
                      handleUpload(e.target.files?.[0]);
                    }}
                  />
                  <InputField
                    label="Link"
                    name="url"
                    setValue={setValue}
                    control={control}
                    defaultValue={data?.data?.url}
                  />
                  <InputNumberWrap
                    label="STT"
                    name="index"
                    defaultValue={data?.data?.index ?? 1}
                    onBlur={(e: any) => {
                      if (e.target.value === "") setValue("index", 1);
                    }}
                    control={control}
                    min={1}
                  />
                  <Form.Item className="checkbox slider_checkbox">
                    <Row>
                      <Col></Col>
                      <Col>
                        <Checkbox
                          defaultChecked={data?.data?.hienthi}
                          name="hienthi"
                          onClick={(e: any) => {
                            setValue("hienthi", e.target.checked);
                          }}
                        />
                        &nbsp;Hiển thị
                      </Col>
                    </Row>
                  </Form.Item>
                  <Row justify="start" gutter={[10, 0]}>
                    <Col>
                      <Button
                        type="primary"
                        danger
                        onClick={handleSubmit(onSubmit)}
                      >
                        Lưu
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        onClick={() => navigate(appRoutes.SLIDERS.HOME.LIST)}
                      >
                        Hủy
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card>
            )}
          </div>
        </>
      }
    />
  );
};

export default SliderHomeForm;
